export default "__VITE_ASSET__CBGma4s1__"